var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpiredRestrictionIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21046",
    d: "M22.275 20.143a2.137 2.137 0 1 0-2.137 2.143 2.14 2.14 0 0 0 2.137-2.143zm-.712 0a1.414 1.414 0 0 1-.2.721l-1.942-1.947a1.405 1.405 0 0 1 .719-.2 1.428 1.428 0 0 1 1.422 1.426zm-2.85 0a1.414 1.414 0 0 1 .2-.721l1.942 1.947a1.405 1.405 0 0 1-.719.2 1.428 1.428 0 0 1-1.424-1.426z",
    transform: "translate(-12.275 -12.286)",
    style: {
      fill: "#f26b2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21047",
    d: "M6.227 2a4.285 4.285 0 1 0 .712 8.507v-.722a3.57 3.57 0 1 1-.712-7.071v3.572l1.547 1.551A2.837 2.837 0 0 1 9.789 7h.648a4.257 4.257 0 0 0-4.21-5z",
    transform: "translate(-1.927 -2)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredRestrictionIconWhite);
export default __webpack_public_path__ + "static/media/expired-restriction-icon-white.49589575bda18e20bff910f0e6cafe03.svg";
export { ForwardRef as ReactComponent };